import Vue from 'vue';
import VueMasonry from 'vue-masonry-css';
import isotope from 'vueisotope';
import imagesLoaded from 'vue-images-loaded';
import { mapActions, mapGetters } from 'vuex';
import sort from '@/utils/Sort';
import PageTitle from '../../components/Pagetitle/Pagetitle';
import Divider from '../../components/Divider/Divider';
import SocialCard from '../../components/SocialCard/SocialCard';
import Label from '../../components/Label/Label';
import Tabs from '../../components/Tabs/Tabs';
import Avatar from '@/components/Avatar/Avatar';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import Input from '@/components/Input/Input';

import Item from '@/models/content/Item';
import Context from '@/models/Context';

Vue.use(VueMasonry);

export default {
  name: 'SocialWall',
  components: {
    PageTitle,
    Divider,
    SocialCard,
    Label,
    Tabs,
    Avatar,
    Modal,
    Button,
    Input,
    isotope
  },
  directives: {
    imagesLoaded
  },
  props: [],
  data() {
    return {
      tabData: [
        { name: 'All', slug: 'all', active: true },
        { name: 'My pinned items', slug: 'pinned' },
        { name: 'From my team', slug: 'team' },
        { name: 'External feeds', slug: 'external' }
      ],
      selectedTab: { name: 'All', slug: 'all', active: true },
      modal: {
        delete: false
      },
      removeCandidate: null,
      removeReason: '',
      isotope_option: {
        percentPosition: true,
        masonry: {
          gutter: 20,
          columnWidth: '.social-card'
        },
        hiddenStyle: {
          opacity: 0
        },
        visibleStyle: {
          opacity: 1
        }
      },
      streamItems: []
    };
  },
  computed: {
    pinnedOnly() {
      return this.selectedTab.slug === 'pinned';
    },

    filteredItems() {
      if (this.pinnedOnly) {
        return this.teamItems.filter(current => {
          return current.isPinned;
        });
      } else {
        return this.teamItems;
      }
    },

    teamItems: function() {
      if (!this.isLoading) {
        const unique = [];
        const result = [];

        Item.query()
          .withAllRecursive()
          .all()
          .forEach(item => {
            if (!unique.includes(item.hash)) {
              unique.push(item.hash);
            }
          });

        unique.forEach(code => {
          const base = Item.query()
            .where(item => {
              return item.hash === code;
            })
            .withAllRecursive()
            .first();

          result.push(base);
        });

        return sort(result, 'createdAtSorter', 'desc');
      } else {
        return null;
      }
    },

    isLoading: function() {
      return this._isLoading();
    },

    isDeleting: function() {
      return this._isDeleting();
    },

    itemsIsLoading: function() {
      return this._itemsIsLoading();
    },

    hasMore: function() {
      return this._hasMore();
    }
  },
  beforeMount() {
    this._pinned();
    this._items();
    this._memberships();
  },
  mounted() {},
  methods: {
    ...mapActions({
      _composerTemplate: 'entities/context/composerTemplate',
      _pinned: 'entities/items/findPinned',
      _items: 'entities/items/findForTeam',
      _findMore: 'entities/items/findMore',
      _memberships: 'entities/memberships/findForTeam',
      _itemLike: 'entities/items/like',
      _itemUnlike: 'entities/items/unlike',
      _itemPin: 'entities/items/pin',
      _itemUnpin: 'entities/items/unpin',
      _itemRemove: 'entities/items/remove',
      _itemUpdate: 'entities/items/update',
      _newToast: 'toasts/_addToast'
    }),
    ...mapGetters({
      _isLoading: 'isLoading',
      _itemsIsLoading: 'entities/items/isLoading',
      _isDeleting: 'entities/items/isDeleting',
      _hasMore: 'entities/items/hasMore'
    }),
    showMore() {
      if (this.hasMore && !this.itemsIsLoading & !this.pinnedOnly) {
        this._findMore();
      }
    },
    updateLike(item) {
      if (item.isLiked) {
        this._itemUnlike(item);
      } else {
        this._itemLike(item);
      }
    },
    updatePin(item) {
      if (item.isPinned) {
        this._itemUnpin(item);
      } else {
        this._itemPin(item);
      }
    },
    removeModal(item) {
      this.removeCandidate = item;
      this.modal.delete = true;
    },
    redo() {
      this.$refs.isotope_wall.layout();
    },
    toComposer(item) {
      this._composerTemplate(item.id).then(() => {
        this.$router.push({ path: '/admin/publish' });
      });
    },
    remove() {
      if (this.removeReason) {
        this.removeCandidate.reason = this.removeReason;

        this._itemUpdate(this.removeCandidate).then(() => {
          this._itemRemove([this.removeCandidate]).then(() => {
            this.removeCandidate = null;
            this.modal.delete = false;

            this._newToast({
              text: 'Item has been successfully removed',
              variant: 'good',
              duration: 2000
            });
          });
        });
      } else {
        this._itemRemove([this.removeCandidate]).then(() => {
          this.removeCandidate = null;
          this.modal.delete = false;

          this._newToast({
            text: 'Item has been successfully removed',
            variant: 'good',
            duration: 2000
          });
        });
      }
    }
  }
};
